import { render, staticRenderFns } from "./CalendarStudent.vue?vue&type=template&id=2eacf436&scoped=true"
import script from "./CalendarStudent.vue?vue&type=script&lang=js"
export * from "./CalendarStudent.vue?vue&type=script&lang=js"
import style0 from "./CalendarStudent.vue?vue&type=style&index=0&id=2eacf436&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eacf436",
  null
  
)

export default component.exports